// app/providers.tsx
'use client'

import { usePathname, useSearchParams } from "next/navigation"
import { useEffect } from "react"
import { usePostHog } from 'posthog-js/react'

import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { key } from "@web-packages/icons/3_informationIcons"

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://eu.i.posthog.com',
      person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
      persistence: 'localStorage',
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: "*",
        maskTextClass: "*"
      },
      before_send: (event) => {
        const sensitiveUrlFields = ['$current_url', '$session_entry_url'];
        sensitiveUrlFields.forEach(field => {
          if (event && event.properties[field]) {
            const url = new URL(event.properties[field]);
            const searchParams = new URLSearchParams(url.search);
            // Replace all parameter values with *
            for (const [key] of searchParams) {
              searchParams.set(key, '*');
            }

            if (searchParams.toString()) {
              event.properties[field] = url.origin + url.pathname + '?' + searchParams.toString();
            }
          }
        });

        if (event && event.properties) {
          const sensitiveFields = ['$el_text', 'value'];
          Object.entries(event.properties).forEach(([key, value]) => {
            if (sensitiveFields.includes(key)) {
              event.properties[key] = '***';
            }
            if (key === '$elements_chain') {
              event.properties[key] = value.replace(/attr__id="([^"]*)"/g, 'attr__id="***"');
              event.properties[key] = value.replace(/text="([^"]*)"/g, 'text="***"');
            }
          });
        }

        if (event && event.properties && Array.isArray(event.properties.elements)) {
          event.properties.elements.forEach(function (element) {
            // Mask text and value fields if present
            if (element.text) element.text = '***';
            if (element.attr__value) element.attr__value = '***';
          });
        }
        return event;
      }
    })
  }, [])

  return (
    <PHProvider client={posthog}>
      {children}
    </PHProvider>
  )
}
